import {values, uniqueId, mapValues} from 'lodash';
import {formatCoordinates} from '../../../utils/formatters';

export default function createPoint(
    action: CreateTrackPointAction,
    tracks: {[trackLocalId: string]: Track},
    setTracks: React.Dispatch<React.SetStateAction<{[trackLocalId: string]: Track}>>
) {

    const {trackLocalId, insertBeforePointLocalId} = action;

    const track = tracks[trackLocalId];
    if (!track.isGeometryLoaded) return '';

    const insertBeforePoint = insertBeforePointLocalId ?
        track.points[insertBeforePointLocalId] :
        undefined;

    const order = insertBeforePoint ?
        insertBeforePoint.properties.order :
        values(track.points).length;

    const pointLocalId = uniqueId('point');
    const point: TrackPoint = {
        type: 'Feature',
        geometry: {
            type: 'Point',
            coordinates: action.lngLat.toArray()
        },
        properties: {
            attr: 'route',
            isLocallyDeleted: false,
            isGeometryModified: true,
            writable: true,
            order,
            pointLocalId,
            title: formatCoordinates(action.lngLat.toArray()),
            trackLocalId,
            isTitleLoaded: true,
            isLocallyCreated: true,
        }
    };

    setTracks({
        ...tracks,
        [trackLocalId]: {
            ...track,
            points: {
                ...mapValues(track.points, (otherPoint: TrackPoint) => {
                    if (otherPoint.properties.isLocallyDeleted) {
                        return otherPoint;

                    } else if (otherPoint.properties.order >= order) {
                        return {
                            ...otherPoint,
                            properties: {
                                ...otherPoint.properties,
                                order: otherPoint.properties.order + 1
                            }
                        };

                    } else {
                        return otherPoint;
                    }

                }),
                [pointLocalId]: point
            }
        }
    });

    return pointLocalId;
}
